import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import c from './LanguageSwitcher.module.scss'

export const LanguageSwitcher = () => {
    const { i18n } = useTranslation()
    const [showLangDropdown, setShowLangDropdown] = useState(false)
    const currentLang = i18n.language || 'ru'

    // Маппинг кодов языков на файлы флагов
    const FLAG_MAP = {
        ru: 'RU',
        en: 'EN',
        ua: 'UA',
        es: 'SP', // Испанский флаг = SP
        pt: 'BR', // Португальский флаг = BR (Бразилия)
        pl: 'PL',
        tr: 'TR',
        ro: 'RO',
        uz: 'UZ',
    }

    const handleLanguageChange = (lang) => {
        console.log('🌍 Manual language change:', lang)
        i18n.changeLanguage(lang)
        localStorage.setItem('i18nextLng', lang)
        // Устанавливаем флаг что язык был выбран вручную (не переопределять из API)
        localStorage.setItem('languageSource', 'manual')
        setShowLangDropdown(false)
    }

    const toggleLangDropdown = () => {
        setShowLangDropdown(!showLangDropdown)
    }

    const currentFlagCode = FLAG_MAP[currentLang] || currentLang.toUpperCase()

    return (
        <div className={c.languageSwitcher}>
            <button className={c.languageButton} onClick={toggleLangDropdown}>
                <img
                    src={`/images/Type=${currentFlagCode}.png`}
                    alt={currentLang.toUpperCase()}
                    className={c.flag}
                />
                <span className={c.langText}>{currentLang.toUpperCase()}</span>
            </button>
            {showLangDropdown && (
                <div className={c.dropdown}>
                    <button
                        onClick={() => handleLanguageChange('ru')}
                        className={c.dropdownItem}
                    >
                        <img
                            src="/images/Type=RU.png"
                            alt="RU"
                            className={c.flag}
                        />
                        <span>RU</span>
                    </button>
                    <button
                        onClick={() => handleLanguageChange('en')}
                        className={c.dropdownItem}
                    >
                        <img
                            src="/images/Type=EN.png"
                            alt="EN"
                            className={c.flag}
                        />
                        <span>EN</span>
                    </button>
                    <button
                        onClick={() => handleLanguageChange('ua')}
                        className={c.dropdownItem}
                    >
                        <img
                            src="/images/Type=UA.png"
                            alt="UA"
                            className={c.flag}
                        />
                        <span>UA</span>
                    </button>
                    <button
                        onClick={() => handleLanguageChange('es')}
                        className={c.dropdownItem}
                    >
                        <img
                            src="/images/Type=SP.png"
                            alt="ES"
                            className={c.flag}
                        />
                        <span>ES</span>
                    </button>
                    <button
                        onClick={() => handleLanguageChange('pt')}
                        className={c.dropdownItem}
                    >
                        <img
                            src="/images/Type=BR.png"
                            alt="PT"
                            className={c.flag}
                        />
                        <span>PT</span>
                    </button>
                    <button
                        onClick={() => handleLanguageChange('pl')}
                        className={c.dropdownItem}
                    >
                        <img
                            src="/images/Type=PL.png"
                            alt="PL"
                            className={c.flag}
                        />
                        <span>PL</span>
                    </button>
                    <button
                        onClick={() => handleLanguageChange('tr')}
                        className={c.dropdownItem}
                    >
                        <img
                            src="/images/Type=TR.png"
                            alt="TR"
                            className={c.flag}
                        />
                        <span>TR</span>
                    </button>
                    <button
                        onClick={() => handleLanguageChange('ro')}
                        className={c.dropdownItem}
                    >
                        <img
                            src="/images/Type=RO.png"
                            alt="RO"
                            className={c.flag}
                        />
                        <span>RO</span>
                    </button>
                    <button
                        onClick={() => handleLanguageChange('uz')}
                        className={c.dropdownItem}
                    >
                        <img
                            src="/images/Type=UZ.png"
                            alt="UZ"
                            className={c.flag}
                        />
                        <span>UZ</span>
                    </button>
                </div>
            )}
        </div>
    )
}

